export const commonRu: Record<string, string> = {
  "hud.mana": "ЭНЕРГИЯ (ЖИЗНЬ)",
  "hud.tempo": "ТЕМП",
  "hud.blessing": "МОЩНОСТЬ",
  "hud.pressSpace": "Пробел - начать волну",
  "hud.chapelCost": "Башня: {{cost}} энергии",
  "hud.wallCost": "Стена: {{cost}} энергии",
  "hud.amplifierCost": "Усилитель: {{cost}} энергии",
  "hud.trapCost": "Ловушка: {{cost}} энергии",
  "hud.modeAmp": "Усилитель",
  "hud.modeTrap": "Ловушка",
  "hud.relicCost": "Гем: {{cost}} энергии",
  "hud.shrineCost": "Святилище: {{cost}} энергии",
  "hud.modeShrine": "Святилище",
  "hud.modeLabel": "Режим [W/A/T/R]:",
  "hud.modeTower": "Башня",
  "hud.modeWall": "Стена",
  "hud.horde": "ВОЛНА",
  "hud.spawned": "{{spawned}}/{{total}} явилось",
  "hud.next": "Дальше:",
  "hud.mobType.Normal": "Обычные",
  "hud.mobType.Swarm": "Рой",
  "hud.mobType.Armored": "Броня",
  "hud.mobType.Giant": "Гиганты",
  "hud.mobType.Runner": "Бегуны",
  "hud.nextDetails": "{{count}}× HP {{hp}}",
  "hud.hint.clickGround": "По земле - башня",
  "hud.hint.keys": "1-8 - создать гем",
  "hud.hint.clickChapel": "По башне - вставить гем",
  "hud.hint.sanctify": "U улучшить  D дубликат  C слить",
  "hud.hint.meltdown": "X расплавить  Пробел - волна",
  "hud.inventory": "Гемы:",
  "hud.noRelics": "Нет гемов (1-8 чтобы создать)",
  "hud.hint.bomb": "Перетащи гем на поле - AoE бомба",
  "hud.settings": "Настройки",
  "battleMenu.title": "Настройки",
  "battleMenu.audioOn": "Звук: вкл",
  "battleMenu.audioOff": "Звук: выкл",
  "battleMenu.resume": "Вернуться к бою",
  "battleMenu.restart": "Перезапустить битву",
  "battleMenu.exit": "Выйти на карту",
  "hud.priest": "Игрок Ур. {{level}}",
  "hud.grace": "Счёт {{grace}}",
  "hud.buildings": "ПОСТРОЙКИ",
  "hud.buildingsHidden": "{{n}} скрыто",
  "hud.relics": "ГЕМЫ",
  "hud.relicsCount": "{{filled}} / {{total}}",
  "hud.actions": "ДЕЙСТВИЯ",
  "hud.actionsHint": "hold [U/D/X]",
  "hud.actionCreate": "Создать",
  "hud.actionDual": "Дуал",
  "hud.actionCombine": "Слить",
  "hud.actionSanctify": "Улучшить",
  "hud.actionBomb": "Бомба",
  "hud.actionMelt": "Расплавить",
  "hud.actionRandom": "Случайная",
  "hud.speed0Title": "Пауза (0x)",
  "hud.speed1Title": "Норма (1x)",
  "hud.speed3Title": "Быстро (3x)",
  "hud.waveCallNext": "Волна {{n}} - вызвать следующую сейчас",
  "hud.waveDone": "Волна {{n}} - завершена",
  "hud.waveLocked": "Волна {{n}} — ещё не доступна",
  "hud.waveLabel": "ВОЛНА",
  "hud.waveTitle": "ВОЛНА {{index}}",
  "hud.waveSpawned": "{{spawned}}/{{total}} явилось",
  "hud.nextTitle": "ДАЛШЕ",
  "hud.nextWaveDetails": "{{mobType}} · {{count}}× HP {{hp}}",
  "hud.topbarWave": "В{{index}} · {{spawned}}/{{total}}",
  "hud.topbarNext": "Дальше: {{mobType}}",
  "hud.prepSpace": "Пробел или Волна 1 - начать защиту",
  "hud.buildChapel": "Башня",
  "hud.buildWall": "Стена",
  "hud.buildAmplifier": "Усилитель",
  "hud.buildTrap": "Ловушка",
  "hud.buildShrine": "Святилище",
  "hud.createGemHint": "Нажми 1-8 для выбора цвета",
  "hud.upgradeCost": "Цена улучшения: {{cost}}",
  "hud.damage": "Урон: {{min}} - {{max}}",
  "hud.range": "Радиус: {{range}}",
  "hud.fireRate": "Темп: {{rate}}/с",
  "map.title": "Tower Defense Engine",
  "map.priestLv": "Игрок Ур. {{level}}",
  "map.xpProgress": "{{xp}} / {{next}} опыта",
  "map.worldMap": "На карту",
  "map.launchCta": "Начать тест",
  "map.startDefense": "Начать тест",
  "settings.title": "Защита — {{field}}",
  "settings.hordeHp": "HP врагов",
  "settings.extraHordes": "Доп. волны",
  "settings.trials": "Модификаторы",
  "settings.resilientHorrors": "Стойкие враги (x2.63 за прорыв)",
  "settings.unholyVigor": "Восстановление врагов (+50% HP при возврате)",
  "settings.graceMult": "Множитель счёта: x{{mult}}",
  "settings.begin": "Начать тест",
  "settings.retreat": "Отступить [Esc]",
  "result.sanctified": "ПОБЕДА!",
  "result.fallen": "ПОРАЖЕНИЕ",
  "result.clickRetreat": "Клик — отступить",
  "story.clickToContinue": "Нажмите, чтобы продолжить...",
  "story.intro.panel1": "Это базовый набор правил: ставь башни, вставляй гемы и не дай врагам дойти до ядра.",
  "story.intro.panel2": "Движку всё равно, какой мир его использует. Кампании дают названия, карту, историю и арт.",
  "story.intro.panel3": "Этот режим нужен, чтобы проверять механику до наложения скина кампании.",
  "story.hollow_one.panel1": "Контрольная точка базового движка пройдена.",
  "summary.title.win": "ПОБЕДА!",
  "summary.title.lose": "ПОРАЖЕНИЕ",
  "summary.kills": "Убито",
  "summary.banishes": "Прорвались",
  "summary.bombs": "Бомб брошено",
  "summary.earlyCalls": "Ранние вызовы волны",
  "summary.earlyLight": "Энергия за ранний спавн",
  "summary.duration": "Длительность",
  "summary.xpEarned": "Счёт заработана",
  "summary.retreat": "Клик — на карту",
  "skills.title": "Улучшения",
  "skills.grace": "Свободно: {{n}} / {{total}}",
  "skills.button": "Скиллы [S]",
  "skills.lvMax": "Ур. {{lv}}/{{max}}",
  "skills.val": "знач: {{v}}",
  "skills.needLevel": "нужен ур. {{req}}",
  "skills.needPoints": "нужно {{cost}}",
  "skills.maxed": "МАКС",
  "skills.costShort": "цена: {{cost}}",
  "skills.addTitle": "Добавить уровень (Shift: добавить сколько возможно)",
  "skills.refundTitle": "Вернуть уровень (Shift: вернуть всё)",
  "skill.0": "Стартовый ресурс",
  "skill.1": "Поток ресурса",
  "skill.2": "Цена прорыва",
  "skill.3": "Цена сборки узлов",
  "skill.4": "Цена структур",
  "skill.5": "Возврат за разбор",
  "skill.6": "Зелёный эффект",
  "skill.7": "Красный эффект",
  "skill.8": "Урон всплеска",
  "skill.9": "Оранжевый эффект",
  "skill.10": "Лаймовый эффект",
  "skill.11": "Сила бустера",
  "skill.12": "Ёмкость ресурса",
  "skill.13": "Двойной узел",
  "skill.14": "Шанс высокого грейда",
  "skill.15": "Фиолетовый эффект",
  "skill.16": "Синий эффект",
  "skill.17": "Сила зарядного узла",
  "skill.18": "Бирюзовый эффект",
  "skill.19": "Жёлтый эффект",
  "skill.20": "Сила дорожного модуля",
  "skill.21": "Урон снарядов",
  "skill.22": "Грейд стартового узла",
  "skill.23": "Время установки",
  "skill.24": "Скорость стрельбы",
  "skill.25": "Дальность",
  "skill.26": "Метки карты в ресурс",
  "skill.desc.0": "Больше стартового ресурса и больший предел ресурса в начале забега.",
  "skill.desc.1": "Быстрее пассивное восстановление ресурса и больше ресурса за побеждённых врагов.",
  "skill.desc.2": "Меньше ресурса тратится на восстановление после прорыва врага.",
  "skill.desc.3": "Меньше ресурса уходит на создание и слияние атакующих узлов.",
  "skill.desc.4": "Меньше ресурса уходит на оборонительные структуры и модули поддержки.",
  "skill.desc.5": "Больше ресурса возвращается при разборе структуры.",
  "skill.desc.6": "Усиливает зелёный эффект урона со временем.",
  "skill.desc.7": "Усиливает красный эффект критического удара.",
  "skill.desc.8": "Повышает урон по площади от детонаций и всплесков.",
  "skill.desc.9": "Усиливает оранжевый эффект по нескольким целям.",
  "skill.desc.10": "Усиливает лаймовый эффект цепного попадания.",
  "skill.desc.11": "Повышает поддержку от соседних структур-бустеров.",
  "skill.desc.12": "Улучшает предел ресурса и связанные открытия.",
  "skill.desc.13": "Улучшает эффективность двухцветных атакующих узлов.",
  "skill.desc.14": "Повышает шанс, что новый узел начнёт с более высоким грейдом.",
  "skill.desc.15": "Усиливает фиолетовый эффект замедления.",
  "skill.desc.16": "Усиливает синий эффект снижения брони.",
  "skill.desc.17": "Повышает урон накопленного заряда специальных узлов.",
  "skill.desc.18": "Усиливает бирюзовый эффект шока.",
  "skill.desc.19": "Усиливает жёлтый эффект получения ресурса за попадание.",
  "skill.desc.20": "Повышает урон и силу переносимых эффектов дорожных модулей.",
  "skill.desc.21": "Повышает прямой урон снарядов всех атакующих узлов.",
  "skill.desc.22": "Улучшает грейд первого случайного атакующего узла на поле.",
  "skill.desc.23": "Снижает задержку установки, переноса и замены атакующих узлов.",
  "skill.desc.24": "Снижает паузу между атаками.",
  "skill.desc.25": "Увеличивает дальность атаки.",
  "skill.desc.26": "Преобразует метки завершённых карт в бонусный стартовый ресурс.",
  "gem.name.Yellow": "Энергия",
  "gem.name.Orange": "Взрыв",
  "gem.name.Red": "Крит",
  "gem.name.Purple": "Замедление",
  "gem.name.Green": "Яд",
  "gem.name.Blue": "Броня",
  "gem.name.Cyan": "Шок",
  "gem.name.Lime": "Цепь",
  "gem.level": "Ур. {{lvl}}",
  "gem.effect.Yellow": "Энергия: +0.3×ур. маны за попадание",
  "gem.effect.Orange": "Взрыв: 14% шанс — полный урон по всем вблизи (радиус 1 кл.)",
  "gem.effect.Red": "Крит: 18% шанс — ×2 урона",
  "gem.effect.Purple": "Замедление: −30% скорость на 2 сек.",
  "gem.effect.Green": "Яд: 8×ур. ур/сек в течение 2.5 сек.",
  "gem.effect.Blue": "Броня: −0.18×ур. брони навсегда",
  "gem.effect.Cyan": "Шок: 17% шанс — оглушение на 1.5 сек.",
  "gem.effect.Lime": "Цепь: 25% шанс — удар по 2-й цели (60% урона)",
  "gem.effectDetail.Yellow": "Мана +{{mana}}",
  "gem.effectDetail.Orange": "Шанс {{chance}} · Радиус {{radius}}",
  "gem.effectDetail.Red": "Шанс {{chance}} · Урон x{{mult}}",
  "gem.effectDetail.Purple": "Замедление {{slow}} · {{duration}}",
  "gem.effectDetail.Green": "Яд {{dps}}/s · {{duration}}",
  "gem.effectDetail.Blue": "Броня -{{armor}}",
  "gem.effectDetail.Cyan": "Шанс {{chance}} · {{duration}}",
  "gem.effectDetail.Lime": "Шанс {{chance}} · Урон {{damage}}",
  "stats.title": "Статистика Игрока",
  "stats.button": "Статистика [I]",
  "stats.summaryHeader": "Сводка",
  "stats.timePlayed": "Время в игре",
  "stats.battles": "Боёв",
  "stats.wins": "Победы",
  "stats.losses": "Поражения",
  "stats.winRate": "Процент побед",
  "stats.killsHeader": "Истребитель",
  "stats.totalKills": "Врагов уничтожено",
  "stats.totalBanishes": "Враги прорвались",
  "stats.earlyHurryHeader": "Ранние волны",
  "stats.manaFromEarlyWaves": "Энергия за ранние волны (всего)",
  "stats.earlyWaveHurries": "Вызовов раньше срока (всего)",
  "stats.fieldsHeader": "Лучшие карты",
  "stats.colField": "Поле",
  "stats.colWins": "П",
  "stats.colFails": "Н",
  "stats.colXp": "Лучший опыт",
  "tutorial.step1": "Клик по земле строит башню",
  "tutorial.step2": "Нажми 1-8, чтобы создать гем",
  "tutorial.step3": "Клик по башне вставляет гем",
  "tutorial.step4": "Пробел начинает волну",
  "tutorial.next": "Далее →",
  "tutorial.skip": "Пропустить",
  "tutorial.firstGem": "Сначала создай гем и поставь его в башню",
  "stats.achievementsHeader": "Достижения",
  "stats.achievementsUnlocked": "{{n}} / {{total}} получено",
  "achievement.first_blood.name": "Первая кровь",
  "achievement.first_blood.desc": "Уничтожь первого врага",
  "achievement.first_victory.name": "Первая победа",
  "achievement.first_victory.desc": "Выиграй первый бой",
  "achievement.slayer_100.name": "Истребитель I",
  "achievement.slayer_100.desc": "Уничтожь 100 врагов",
  "achievement.slayer_1000.name": "Истребитель II",
  "achievement.slayer_1000.desc": "Уничтожь 1000 врагов",
  "achievement.banisher_100.name": "Изгоняющий",
  "achievement.banisher_100.desc": "Позволь 100 врагам прорваться к ядру",
  "achievement.battles_10.name": "Ветеран",
  "achievement.battles_10.desc": "Начни 10 боёв",
  "achievement.battles_50.name": "Чемпион",
  "achievement.battles_50.desc": "Начни 50 боёв",
  "achievement.played_1h.name": "Посвящённый",
  "achievement.played_1h.desc": "Играй суммарно 1 час",
  "achievement.fields_5.name": "Исследователь",
  "achievement.fields_5.desc": "Пройди 5 разных карт",
  "achievement.fields_20.name": "Завоеватель",
  "achievement.fields_20.desc": "Пройди 20 разных карт",
  "achievement.priest_level_5.name": "Адепт",
  "achievement.priest_level_5.desc": "Достигни 5 уровня игрока",
  "achievement.priest_level_10.name": "Мастер",
  "achievement.priest_level_10.desc": "Достигни 10 уровня игрока",
  "achievement.early_wave_light_100.name": "Смелый срок I",
  "achievement.early_wave_light_100.desc": "Собрать 100 энергии за ранние волны (всего)",
  "achievement.early_wave_light_2000.name": "Смелый срок II",
  "achievement.early_wave_light_2000.desc": "Собрать 2000 энергии за ранние волны (всего)",
  "achievement.early_wave_light_50000.name": "Смелый срок III",
  "achievement.early_wave_light_50000.desc": "Собрать 50000 энергии за ранние волны (всего)",
  "achievement.early_wave_light_100000.name": "Смелый срок IV",
  "achievement.early_wave_light_100000.desc": "Собрать 100000 энергии за ранние волны (всего)",
  "achievement.early_wave_calls_500.name": "Неустанный вестник",
  "achievement.early_wave_calls_500.desc": "500 ранних вызовов спавна (всего)",
  "hud.fieldLocked": "Поле ещё не разблокировано",
  "hud.fieldLockedHint": "Пройди соседнее поле",
  "toast.levelUp": "Уровень {{level}}!",
  "toast.levelUpSubtitle": "Твоя сила растёт",
  "toast.giftsUnlocked": "Открыты новые дары",
  "toast.giftUnlockedSubtitle": "{{name}} - очков доступно: {{points}}",
  "toast.giftsUnlockedSubtitle": "Новых улучшений: {{count}} - очков доступно: {{points}}",
  "toast.giftsAvailable": "Есть очки",
  "toast.giftsAvailableSubtitle": "Очки: {{points}}",
  "toast.earlyWaveManaTitle": "+{{n}} энергии",
  "toast.earlyWaveManaSubtitle": "Ранний вызов волны",
  "locale.toggle": "РУ",
  "mobile.rotateDevice": "Поверните устройство горизонтально",
  "summary.xp": "Счёт получен",
};
